(function () {
    let swiper = null;

    function handleSwiper() {
        if (window.innerWidth > 767) {
            if (!swiper) {
                swiper = new Swiper(".compare-slider", {
                    slidesPerView: 2,
                    spaceBetween: 10
                });
            }
        } else {
            if (swiper) {
                swiper.destroy(true, true);
                swiper = null;
            }
        }
    }

    handleSwiper();
    window.addEventListener("resize", handleSwiper);
})();